import React from 'react';
import EntityDrawer from '../ui/EntityDrawer';
import ReservationEditorPanel, { ReservationEditorInitialValues } from './ReservationEditorPanel';

type ReservationEditorModalProps = {
  open: boolean;
  reservationId: string | null;
  onClose: () => void;
  onSaved?: (reservation: any) => void;
  initialValues?: ReservationEditorInitialValues;
};

export default function ReservationEditorModal({
  open,
  reservationId,
  onClose,
  onSaved,
  initialValues,
}: ReservationEditorModalProps) {
  const isEditing = Boolean(reservationId);
  const title = isEditing ? 'Edit Reservation' : 'Create Reservation';
  const description = isEditing
    ? 'Update reservation details and customer/accounting attachments.'
    : 'Create a thin reservation record for accounting and operational tracking. This does not create a booking-session user.';

  return (
    <EntityDrawer
      open={open}
      title={title}
      subtitle={description}
      onClose={onClose}
      widthClassName="max-w-3xl"
    >
      <ReservationEditorPanel
        reservationId={reservationId}
        initialValues={initialValues}
        onSaved={(reservation) => {
          onSaved?.(reservation);
          onClose();
        }}
        onCancel={onClose}
      />
    </EntityDrawer>
  );
}

// ── Dead code below this line (replaced by thin wrapper above) ──────────────
// Keep this comment so the file boundary is clear. All form logic lives in
